export const SORT_OPTIONS = [
  { value: 'reference_asc', label: 'Référence croissant' },
  { value: 'reference_desc', label: 'Référence décroissant' },
  { value: 'price_asc', label: 'Prix croissant' },
  { value: 'price_desc', label: 'Prix décroissant' },
  { value: 'name_asc', label: 'Nom A → Z' },
];

export const PRODUCT_FILTERS = [
  { name: 'Nouveau', id: 'new' },
  { name: 'Disponible', id: 'available' },
  { name: 'En promotion', id: 'promo' },
];
